import classNames from 'classnames';

import { Select } from '../../atoms';

export type SmsBundleTierOption = {
  value: string;
  label: string;
  disabled?: boolean;
};

export type SmsBundleTierSelectProps = {
  label: string;
  options: SmsBundleTierOption[];
  value: SmsBundleTierOption['value'] | undefined;
  onChange: (value: SmsBundleTierOption['value']) => void;
  disabled: boolean;
  inConfiguratorRow?: boolean;
  valueFocusedMWebInline?: boolean;
  ariaLabel?: string;
  placeholder?: string;
};

export const SmsBundleTierSelect = ({
  options,
  value,
  onChange,
  label,
  disabled,
  inConfiguratorRow = false,
  valueFocusedMWebInline = false,
  ariaLabel,
  placeholder,
}: SmsBundleTierSelectProps) => (
  <div
    // Radix Select does not reliably clear the trigger label when a controlled `value`
    // goes from a tier id back to `undefined`; remount when selection clears so the
    // placeholder shows again (e.g. after "Remove SMS" on email plan cards).
    key={value ?? 'sms-bundle-tier-unselected'}
    className={classNames('payflow-ui', 'sms-bundle-tier-select-container', {
      'sms-bundle-tier-select-container--in-row': inConfiguratorRow,
      'sms-bundle-tier-select-container--value-focused-mweb-inline': valueFocusedMWebInline,
      'pricing-configurator__box': !inConfiguratorRow && !valueFocusedMWebInline,
    })}
  >
    <Select
      className="tier-select"
      fullWidth
      disabled={disabled}
      name="sms-bundle-tier-select"
      ariaLabel={valueFocusedMWebInline ? ariaLabel : undefined}
      label={label}
      options={options}
      value={value}
      placeholder={placeholder}
      onValueChange={onChange}
      variant={inConfiguratorRow || valueFocusedMWebInline ? 'rounded' : 'regular'}
    />
  </div>
);
